export default "__VITE_ASSET__Im2GbDps__"